import { useCallback, useState } from "react";
import { useAxiosInterceptor } from "src/hooks/useAxiosInterceptor";
import { useAuth } from "src/contexts/auth-provider";
import { GRAPHQL_ENDPOINT } from "src/constants/endpoints";
import { ADD_MODIFIER_ITEM_OPTION } from "src/constants/mutations";
import { successToast } from "src/utils/toasts";
import { AddModifierItemOptionInput } from "src/interfaces/modifier.interface";
import { useModifierItemsByCategoryCorrelationId } from "./useModifierItemsByCategoryCorrelationId";

export const useAddModifierItemOption = () => {
  const { axBe } = useAxiosInterceptor();
  const { hasRestaurant } = useAuth();
  const { fetchModifierItemsByCategoryCorrelationId } = useModifierItemsByCategoryCorrelationId();

  const [isAddingModifierItemOption, setIsAddingModifierItemOption] = useState(false);

  const addModifierItemOption = useCallback(async (addModifierItemOptionInput: AddModifierItemOptionInput) => {
    if (!hasRestaurant?.correlationId) {
      return null;
    }

    setIsAddingModifierItemOption(true);
    try {
      const { data } = await axBe.post(GRAPHQL_ENDPOINT, {
        query: ADD_MODIFIER_ITEM_OPTION,
        variables: {
          addModifierItemOptionInput,
        },
      });

      if (data?.data?.addModifierItemOption) {
        successToast("Modifier item option added successfully");
        
        // Refresh all modifier items to sync data
        await fetchModifierItemsByCategoryCorrelationId();
      } else {
        throw new Error("Failed to add modifier item option");
      }
    } catch (err) {
      console.error("Error adding modifier item option:", err);
      return null;
    } finally {
      setIsAddingModifierItemOption(false);
    }
  }, [axBe, hasRestaurant?.correlationId, fetchModifierItemsByCategoryCorrelationId]);

  return {
    addModifierItemOption,
    isAddingModifierItemOption,
  };
};
